export default __webpack_public_path__ + "static/media/cpd.9744fabc.png";